var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-quote-left';
                    var viewUrl = 'sprite.svg#view-icon-quote-left';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 56 48',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };